export default __webpack_public_path__ + "assets/bookmark2.1ced3096.gif";